<template>
    <div>
      <ledes-type-list></ledes-type-list>
      </div>
  </template>
  <script>
  export default {};
  </script>